<template>
  <base-dialog @cancel="cancelDialog" width="900px">
    <div slot="header">{{ $t('monitor.resource_template.add_builtin_metric') }}</div>
    <div slot="body">
      <div v-if="!isContainer" class="mb-2 d-flex align-items-center">
        <span class="mr-2">{{ $t('monitor.resource_template.filter_hypervisor') }}</span>
        <a-select
          v-model="hypervisor"
          allowClear
          style="width: 180px"
          :placeholder="$t('monitor.resource_template.match_all')"
          @change="refresh">
          <a-select-option v-for="item in hypervisorOptions" :key="item.value" :value="item.value">{{ item.label }}</a-select-option>
        </a-select>
      </div>
      <a-table
        size="small"
        rowKey="rowKey"
        :columns="columns"
        :dataSource="list"
        :pagination="{ pageSize: 8 }"
        :customRow="customRow" />
    </div>
    <div slot="footer">
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'
import {
  getRecommendCatalog,
  isFlatTemplateCategory,
  HYPERVISOR_FILTER_OPTIONS,
  MONITOR_TYPE_OPTIONS,
  panelKey,
} from '../components/monitorTemplateCatalog'

export default {
  name: 'RecommendMonitorTemplateDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      hypervisor: undefined,
      list: [],
      hypervisorOptions: HYPERVISOR_FILTER_OPTIONS.map(item => ({ value: item.key, label: item.label })),
      columns: [
        { title: this.$t('monitor.resource_template.panel_name'), dataIndex: 'metricName' },
        {
          title: this.$t('monitor.resource_template.monitor_type'),
          dataIndex: 'monitor_type',
          customRender: val => this.monitorTypeLabel(val),
        },
        { title: this.$t('monitor.resource_template.recommend_tip'), dataIndex: 'recommend_tip' },
        {
          title: this.$t('common.action'),
          key: 'action',
          customRender: (text, row) => {
            return <a onClick={() => this.handleApply(row)}>{ this.$t('monitor.resource_template.apply') }</a>
          },
        },
      ],
    }
  },
  computed: {
    // 当前策略类型，决定推荐哪类资源的监控指标
    category () {
      return this.params && this.params.category
    },
    // 宿主机/容器主机/容器没有平台差异，不需要按平台筛选
    isContainer () {
      return isFlatTemplateCategory(this.category)
    },
  },
  created () {
    this.refresh()
  },
  methods: {
    monitorTypeLabel (val) {
      const hit = MONITOR_TYPE_OPTIONS.find(item => item.key === val)
      return hit ? hit.label : (val || '-')
    },
    refresh () {
      const list = getRecommendCatalog({
        category: this.category,
        hypervisor: this.isContainer ? undefined : this.hypervisor,
      })
      this.list = list.map((item, index) => ({
        ...item,
        // 监控名称统一展示为「CPU使用率(agent_cpu.usage_active)」格式
        metricName: `${item.label}(${item.fromItem}.${item.seleteItem})`,
        rowKey: `${panelKey(item)}_${index}`,
      }))
    },
    customRow (row) {
      return {
        on: {
          dblclick: () => this.handleApply(row),
        },
      }
    },
    handleApply (row) {
      this.params.onApply && this.params.onApply(row)
      this.cancelDialog()
    },
  },
}
</script>
